module.exports = __webpack_public_path__ + "static/euflag-7319701860317798127d6d7d6fd86415.svg";